import axios from 'axios';
import TokenService from './token.service';
import { attachAuthRefreshInterceptor } from './authInterceptor';

const baseURL = process.env.REACT_APP_API_URL;

const bilAPI = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'multipart/form-data',
    accept: 'application/json',
    'Accept-Language': localStorage.getItem('i18nextLng'),
  },
});

bilAPI.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    } else {
      config.headers['Authorization'] = null;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

attachAuthRefreshInterceptor(bilAPI);

export default bilAPI;
